export default __webpack_public_path__ + "static/media/spain.5dc52861.webp";